import { render, staticRenderFns } from "./MyMiniGameRanking.vue?vue&type=template&id=281e72cc&"
import script from "./MyMiniGameRanking.vue?vue&type=script&lang=js&"
export * from "./MyMiniGameRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports